import { styled } from '@openeducation/oe-it-themes';
import { isEqual } from '@openeducation/oe-it-utils';
import * as React from 'react';
import { LayoutChangeEvent, View } from 'react-native';

import { ToggleButtonGroup } from '../../atoms/toggle-button';
import ToggleButton, {
  CheckbokHorizontalAlignmentType,
} from '../../atoms/toggle-button/toggle-button';
import { flex, width } from '../../style-utils';

export interface ToggleButtonGridProps<T> {
  onItemSelected: (value?: T) => void;
  items?: {
    label: string;
    value?: T;
  }[];
  selectedItem?: T;
  horizontalSpacing?: number;
  columns?: number;
  horizontalAlignment?: CheckbokHorizontalAlignmentType;
}

export const ToggleButtonGrid = <T extends unknown>({
  items = [],
  onItemSelected,
  columns = 1,
  horizontalSpacing = 0,
  horizontalAlignment = 'center',
  selectedItem,
}: ToggleButtonGridProps<T>) => {
  const [cellWidth, setCellWidth] = React.useState<string | number>('');

  const handleItemSelect = (value?: T[]) => {
    if (onItemSelected) onItemSelected(value?.[0]);
  };

  const onGridLayout = (event: LayoutChangeEvent) => {
    const containerWidth = event?.nativeEvent.layout.width;
    const width =
      columns <= 1
        ? '100%'
        : (containerWidth * 1) / columns - horizontalSpacing * 2;
    width && setCellWidth(width);
  };

  return (
    <ToggleButtonGroup<T>
      onChange={handleItemSelect}
      onLayout={onGridLayout}
      style={[
        flex('flex-row', 'justify-content-between', 'flex-wrap'),
        width('100%'),
      ]}
    >
      {items.map(({ label, value }, index) => (
        <GridCell key={`${value}-${index}`} cellWidth={cellWidth}>
          <ToggleButton<T>
            selected={isEqual(selectedItem, value)}
            horizontalAlignment={horizontalAlignment}
            label={label}
            value={value}
          />
        </GridCell>
      ))}
    </ToggleButtonGroup>
  );
};

interface ColumnsProp {
  cellWidth: number | string;
}

const GridCell = styled(View)<ColumnsProp>`
  height: 40px;
  margin-bottom: 4px;
  margin-top: 4px;
  justify-content: center;
  width: ${({ cellWidth }) => (cellWidth ? `${cellWidth}px` : 'auto')};
`;
